import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { servicesData } from '../data/servicesData';

function ServiceCard({ service, index }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Link to={`/services/${service.id}`} className="block h-full">
      <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }} transition={{ delay: index * 0.1, type: 'spring', stiffness: 100 }}
        onHoverStart={() => setHovered(true)} onHoverEnd={() => setHovered(false)}
        whileHover={{ y: -12 }} className="relative group cursor-pointer h-full">
        <div className="relative bg-gradient-to-br from-gray-50/90 dark:from-gray-900/90 to-white/90 dark:to-black/90 p-10 rounded-3xl border border-gray-200 dark:border-gray-800 group-hover:border-cyan-500/40 transition-all duration-500 backdrop-blur-md h-full overflow-hidden flex flex-col">
          <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent"
            initial={{ x: '-100%' }} whileHover={{ x: '100%' }} transition={{ duration: 0.6 }} />
          <motion.div whileHover={{ rotate: 360, scale: 1.1 }} transition={{ duration: 0.8 }}>
            <div className={`w-24 h-24 mb-8 rounded-2xl bg-gradient-to-br ${service.gradient} flex items-center justify-center shadow-2xl relative overflow-hidden`}>
              <service.icon className="text-5xl text-white relative z-10" />
              <motion.div animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0.8, 0.5] }}
                transition={{ duration: 2, repeat: Infinity }} className="absolute inset-0 bg-white/20 rounded-2xl" />
            </div>
          </motion.div>
          <h3 className="text-2xl font-black mb-4 text-gray-900 dark:text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-cyan-400 group-hover:to-orange-400 transition-all">
            {service.title}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-6 flex-grow">{service.description}</p>
          <div className="space-y-3 mt-auto">
            {service.features.map((f, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${service.gradient}`} />
                <span className="text-sm text-gray-500 font-medium">{f}</span>
              </div>
            ))}
          </div>
          <motion.div initial={{ opacity: 0, x: -10 }} animate={hovered ? { opacity: 1, x: 0 } : { opacity: 0, x: -10 }}
            className="absolute bottom-8 right-8">
            <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${service.gradient} flex items-center justify-center shadow-lg`}>
              <FaArrowRight className="text-white" />
            </div>
          </motion.div>
        </div>
      </motion.div>
    </Link>
  );
}

export default function Services() {
  return (
    <section id="services" className="py-32 px-4 relative">
      <div className="max-w-7xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} className="text-center mb-20">
          <motion.span whileHover={{ scale: 1.05 }}
            className="inline-block px-6 py-2 bg-gradient-to-r from-cyan-500/10 to-orange-500/10 border border-cyan-500/20 rounded-full text-sm font-semibold text-cyan-400 mb-6 backdrop-blur-sm">
            What We Offer
          </motion.span>
          <h2 className="text-5xl md:text-7xl font-black mb-6">
            Premium <span className="bg-gradient-to-r from-cyan-400 to-orange-500 bg-clip-text text-transparent">Services</span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
            End-to-end digital solutions designed to transform your business and drive sustainable growth
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
          {servicesData.map((s, i) => <ServiceCard key={s.title} service={s} index={i} />)}
        </div>
      </div>
    </section>
  );
}
